module.exports = __webpack_public_path__ + "static/media/Accelgor_gaussian2.c46c4b3b.png";